import { sortArray } from "components/results/analysis-results/sortUtil";
import { GroupTableType } from "helpers/models";
import { Content } from "pdfmake/interfaces";
import gap from "report/common/gap";
import getLayer from "report/common/layer";
import tableColumn from "report/common/table-column-line";

const get = (
  t: any,
  grouped: GroupTableType,
  aggregationUnits: string[],
  unit: string,
  currency: string,
  layerTitle: { [key: string]: string },
  distanceUnit: "m" | "km",
  lineLength: string
): Content[] => {
  const layerArray = Object.keys(grouped)
    .sort((a, b) => {
      return sortArray.indexOf(a) - sortArray.indexOf(b);
    })
    .map((e) => {
      const title = layerTitle[e];
      const titleTranslate =
        title && "" !== title ? t(`legend.${title}`) : undefined;
      return [
        {
          stack: [
            getLayer(t, e, 10, 1),
            gap(10),
            tableColumn(
              t,
              grouped[e],
              aggregationUnits,
              e === "EQ_Tsunami_SwissRe"
                ? t("legend.2500y Wave Height [m]")
                : titleTranslate,
              unit,
              distanceUnit,
              lineLength
            )
          ],
          unbreakable: true
        },

        gap(30)
      ];
    });

  return [layerArray];
};

export default get;
